__turbopack_context__.v({
  "addBtn": "TeamProjectsView-module-scss-module__sKSjtG__addBtn",
  "addBtnLabel": "TeamProjectsView-module-scss-module__sKSjtG__addBtnLabel",
  "empty": "TeamProjectsView-module-scss-module__sKSjtG__empty",
  "projects": "TeamProjectsView-module-scss-module__sKSjtG__projects",
  "seeAllBtn": "TeamProjectsView-module-scss-module__sKSjtG__seeAllBtn",
  "seeAllBtnLabel": "TeamProjectsView-module-scss-module__sKSjtG__seeAllBtnLabel",
  "showAll": "TeamProjectsView-module-scss-module__sKSjtG__showAll",
});
